import { render } from "./StepTwoRegistration.vue?vue&type=template&id=f64175de&scoped=true"
import script from "./StepTwoRegistration.vue?vue&type=script&lang=js"
export * from "./StepTwoRegistration.vue?vue&type=script&lang=js"

import "./StepTwoRegistration.vue?vue&type=style&index=0&id=f64175de&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f64175de"]])

export default __exports__